<template>

  <b-container fluid style="margin-bottom: 50px;">
    <m-pages-1 :havePagination="true" class="mt-5"/>
  </b-container>

</template>

<script>

export default {
  name: "Pages",
}
</script>

<style scoped>

</style>